import { campaignBoardKey, type CampaignRecord } from '@workspace/types';

export type CampaignBoardStatus = 'DRAFT' | 'STARTED' | 'PAUSED' | 'RESUMED' | 'STOPPED';

const BOARD_STATUS: Record<ReturnType<typeof campaignBoardKey>, CampaignBoardStatus> = {
  draft: 'DRAFT',
  started: 'STARTED',
  paused: 'PAUSED',
  resumed: 'RESUMED',
  stopped: 'STOPPED',
};

export const CAMPAIGN_BOARD_LABEL: Record<CampaignBoardStatus, string> = {
  DRAFT: 'Borrador',
  STARTED: 'Iniciada',
  PAUSED: 'Pausada',
  RESUMED: 'Reanudada',
  STOPPED: 'Detenida',
};

export function campaignBoardStatus(campaign: Pick<CampaignRecord, 'status' | 'resumedAt'>): CampaignBoardStatus {
  return BOARD_STATUS[campaignBoardKey(campaign.status, campaign.resumedAt)];
}

export function campaignStatusButton(status: CampaignRecord['status']): {
  label: string;
  next: CampaignRecord['status'];
} | null {
  if (status === 'ACTIVE') {
    return { label: 'Pausar', next: 'PAUSED' };
  }
  if (status === 'PAUSED') {
    return { label: 'Reanudar', next: 'ACTIVE' };
  }
  if (status === 'DRAFT') {
    return { label: 'Iniciar campaña', next: 'ACTIVE' };
  }
  return null;
}

export function canEditAudience(status: CampaignRecord['status']): boolean {
  return status === 'DRAFT';
}

export function canStopCampaign(status: CampaignRecord['status']): boolean {
  return status === 'ACTIVE' || status === 'PAUSED';
}
